
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public/resources/[pid]",
      function () {
        return require("private-next-pages/public/resources/[pid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public/resources/[pid]"])
      });
    }
  